(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.frontendViewDistributorLocationFinder = {
    attach: function (context) {
      var $submit = $('.paragraph-view-distributors-location-finder-lane__view button[type="submit"]');

      $submit.hide();

      $('select[name="distributor__country_value"]').change(function () {
        $submit.click();
      });
    }
  };

})(Drupal, jQuery);
